export default "__VITE_PUBLIC_ASSET__6f14c2c0__"